import React from 'react';
import {
  Dropdown,
  DropdownOverlay,
  SelectInput,
  ActionList,
  ActionListItem,
  Spinner,
  Box,
  Text,
} from '@razorpay/blade/components';
import { statesOfIndia } from 'utils/StatesOfIndia';
import { CustomSelectInputProps } from '../types';
import { useQuery } from 'react-query';
import api from 'api';

export const SelectDistrict = ({ register, formData, onChangeSuccess }: CustomSelectInputProps) => {
  const selectedState =
    statesOfIndia.find((s) => s.code.toString() === formData?.state?.[0])?.esicState || '';
  const selectedDistrict = formData?.district?.[0];

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['districts', selectedState],
    queryFn: () => api.officeLocation.fetchDistricts({ state: selectedState }),
    enabled: !!selectedState,
  });

  return (
    <Dropdown selectionType="single" _width="50%">
      <SelectInput
        label="District"
        necessityIndicator="required"
        placeholder="Choose District"
        {...register({ name: 'district', type: 'select', onSuccess: onChangeSuccess })}
      />
      <DropdownOverlay>
        {isLoading || isFetching ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap="spacing.5"
            padding="spacing.5">
            <Spinner accessibilityLabel="loading states" />
          </Box>
        ) : data?.length ? (
          <ActionList>
            {data?.map((district) => (
              <ActionListItem
                key={district}
                title={district}
                value={district}
                isSelected={selectedDistrict === district}
              />
            ))}
          </ActionList>
        ) : (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="spacing.5"
            padding="spacing.5">
            <Box display="flex" flexDirection="column" gap="spacing.3">
              <Text size="medium" weight="semibold" textAlign="center">
                No Districts Present
              </Text>
            </Box>
          </Box>
        )}
      </DropdownOverlay>
    </Dropdown>
  );
};
